export const sessionKeys = {
    user: "nl_user",
    departures: "nl_departures",
    basket: "nl_basket",
    token: "nl_token",
    dates: "nl_dates",
};
